import { useState, useEffect, useCallback } from "react";
import { listTenants } from "../../../../services/platform_admin_service";

const DAY_MS = 1000 * 60 * 60 * 24;

const daysSince = (isoDate) => {
    if (!isoDate) return null;
    const time = new Date(isoDate).getTime();
    if (Number.isNaN(time)) return null;
    return Math.max(0, Math.floor((Date.now() - time) / DAY_MS));
};

const formatLastAccess = (days) => {
    if (days === null) return "Sem registro";
    if (days === 0) return "Hoje";
    if (days === 1) return "Ontem";
    if (days < 30) return `${days} dias atrás`;
    const months = Math.floor(days / 30);
    return months === 1 ? "1 mês atrás" : `${months} meses atrás`;
};

/**
 * Risco de churn a partir de dados reais:
 * - status bloqueado/cancelado/expirado → crítico
 * - healthScore (quando calculado) tem prioridade
 * - fallback: dias desde a última atividade
 */
const computeChurnRisk = (tenant, inactiveDays) => {
    if (["blocked", "cancelled", "expired"].includes(tenant.status)) return "critico";
    if (tenant.healthScore !== null && tenant.healthScore !== undefined) {
        if (tenant.healthScore < 40) return "critico";
        if (tenant.healthScore < 55) return "alto";
        if (tenant.healthScore < 70) return "medio";
        return "baixo";
    }
    if (inactiveDays === null) return "medio";
    if (inactiveDays > 30) return "critico";
    if (inactiveDays > 14) return "alto";
    if (inactiveDays > 7) return "medio";
    return "baixo";
};

const usePlatformMetrics = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchMetrics = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const result = await listTenants({ page: 1, pageSize: 100 });
            const mapped = (result.items || []).map(t => {
                const inactiveDays = daysSince(t.lastActivityAt);
                return {
                    id: t.id,
                    name: t.name,
                    lastAccess: formatLastAccess(inactiveDays),
                    inactiveDays,
                    healthScore: t.healthScore,
                    planId: t.planId,
                    churnRisk: computeChurnRisk(t, inactiveDays),
                    status: t.status,
                };
            });
            setItems(mapped);
        } catch (err) {
            console.error("[usePlatformMetrics]", err);
            setError(err.message || "Erro ao carregar métricas de engajamento.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMetrics();
    }, [fetchMetrics]);

    return { items, loading, error, refetch: fetchMetrics };
};

export default usePlatformMetrics;
